<template>
    <v-menu
            ref="menu"
            v-model="active"
            :close-on-click="true"
            :close-on-content-click="false"
            :return-value.sync="innerDate"
            :style="{width:width+'px'}"
            max-width="290px"
            min-width="290px"
            offset-y
            transition="scale-transition"
    >
        <template v-slot:activator="{ on }">
            <v-text-field
                    v-model="innerDate"
                    :label="label"
                    readonly
                    outlined
                    dense
                    hide-details
                    :disabled="disable"
                    v-on="on"
            />
        </template>
        <v-date-picker v-model="innerDate"
                       :day-format="format"
                       :locale="locale"
                       :type="innerType"
                       scrollable
>
            <v-btn v-if="!!innerDate && clearBtn" color="primary" text @click="onResetClicked">
{{ '초기화' | translate }}
</v-btn>
<!--            <v-btn @click="onConfirmClicked" color="primary" text>{{'확인' | translate}}</v-btn>-->
        </v-date-picker>
    </v-menu>
</template>

<script>
    import {DateTime} from 'luxon';
    import CoreDate from "./CoreDate";

    export default {
        name: "SearchDatePicker",
        mixins: [CoreDate],
        props: {
            value: null,
            width: {
                type: Number,
                default: 80
            },
            label: String,
            type: {
                type: String,
                default: 'date'
            },
            now: {
                type: Boolean,
                default: false,
            },
            disable:{
                type: Boolean,
                default: false,
            },
            clearBtn: {
              type: Boolean,
              default: true,
            },
        },

        data() {
            return {
                active: false,
                innerDate: null,
            }
        },

        computed: {
            styleObject() {
                return {
                    width: this.width + 'px',
                };
            },
            innerType() {
                return this.type === 'month' ? 'month' : 'date';
            },
        },


        watch: {
            value(newValue, oldValue) {
                if (this.toISO(this.innerDate) === newValue) return;
                this.updateInnerDate(newValue);
            },

            innerDate() {
                this.onConfirmClicked();
            }
        },

        created() {
            if (this.value !== null) {
                this.updateInnerDate(this.value);
            } else if (this.now) {
                this.updateInnerDate(this.$now());
            }
        },

        methods: {
            onResetClicked() {
                this.innerDate = null;
                this.$refs.menu.save(this.innerDate);
                this.$emit('input', null);
                this.$emit('update:date', null);
            },

            updateInnerDate(date) {
                this.innerDate = this.toInnerISODate(date, this.innerType);
                let isoDate = this.toISO(this.innerDate);
                this.$emit('input', isoDate);
                this.$emit('update:innerDate', isoDate);
            },

            onCancelClicked() {
                this.updateInnerDate();
                this.active = false;
            },

            onConfirmClicked() {
                this.innerDate = this.toInnerISODate(this.innerDate, this.innerType);
                this.$refs.menu.save(this.innerDate);
                let isoDate = this.toISO(this.innerDate);
                this.$emit('input', isoDate);
                this.$emit('update:date', isoDate);
            },

            format(date) {
                return DateTime.fromISO(date).get('day');
            },

            clear() {
                this.innerDate = null;
            },
        }
    }
</script>

<style scoped>
    >>>input:read-only, >>>input {
        background-color: transparent !important;
        border: 0 !important;
    }
</style>
